import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Button from "../Button";

import settings from "../../config";
import Header from "../Header";
import Select from "../Select/Select";
import Input from "../Input/Input";

const FabricVariantTransactionForm = () => {
  const navigate = useNavigate();
  const { fabricTransactionId = "", fabricVariantTransactionId = null } =
    useParams();
  const [variants, setVariants] = useState([]);

  const [formData, setFormData] = useState({
    fabricTransactionId,
    fabricVariantTransactionId,
    variantId: "",
    variantCode: "",
    variantType: "",
    quantity: "",
    price: "",
    processingDate: "",
    category: "",
    status: 0,
    seasonId: "",
  });

  const [seasons, setSeasons] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}seasons/`);

      if (response.data.statusCode === 200) {
        setSeasons(response.data.data);
      }
    })();
  }, []);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}variants/`);

      setVariants(response.data.data);
    })();
  }, []);

  useEffect(() => {
    if (fabricVariantTransactionId) {
      (async () => {
        const response = await axios.post(
          `${settings.api}fabric/variant-view-transaction`,
          {
            fabricVariantTransactionId,
          },
        );

        setFormData(response.data.data[0]);
      })();
    }
  }, [fabricVariantTransactionId]);

  useEffect(() => {
    if (fabricVariantTransactionId) {
      (async () => {
        const response = await axios.post(
          `${settings.api}fabric/variant-view-transaction`,
          {
            fabricVariantTransactionId,
          },
        );

        setFormData(response.data.data[0]);
      })();
    }
  }, [fabricVariantTransactionId]);

  return (
    <form
      dir="rtl"
      onSubmit={async (e) => {
        e.preventDefault();

        const response =
          (fabricVariantTransactionId &&
            (await axios.post(
              `${settings.api}fabric/update-variant-transaction`,
              formData,
            ))) ||
          (await axios.post(
            `${settings.api}fabric/create-variant-transaction`,
            formData,
          ));

        if (response.data.statusCode === 200) {
          navigate(`/fabric/variants/${fabricTransactionId}`);
        }
      }}
    >
      <div className="w-full">
        <Header title="استماره دفعات المنتجات" />
        <div className="flex flex-col w-full lg:w-1/2 m-auto gap-4">
          <Select
            label="الاصناف"
            value={formData.variantId}
            onChange={onChange}
            name="variantId"
            required
          >
            <option value="">اختر</option>
            {variants.map((variant) => (
              <option key={variant.variantId} value={variant.variantId}>
                {variant.variantName}
              </option>
            ))}
          </Select>

          <Input
            label="كود الصنف"
            value={formData.variantCode}
            onChange={onChange}
            name="variantCode"
          />

          <Input
            label="نوع الصنف"
            value={formData.variantType}
            onChange={onChange}
            name="variantType"
            required
          />

          <Input
            label="العدد"
            value={formData.quantity}
            onChange={onChange}
            name="quantity"
            required
          />

          <Input
            label="سعر القماش للقطعه"
            value={formData.price}
            onChange={onChange}
            name="price"
            required
          />

          <Select
            label="الحاله"
            value={formData.status}
            onChange={onChange}
            name="status"
            required
          >
            <option value="0">اختر</option>
            <option value="1">دوره تشغيل</option>
            <option value="2">فى المخزن</option>
          </Select>

          <Input
            label="القسم"
            value={formData.category}
            onChange={onChange}
            name="category"
            required
          />

          <Input
            label="تاريخ الدفعه"
            value={formData.processingDate}
            onChange={onChange}
            name="processingDate"
            required
            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
            placeholder="yyyy-mm-dd"
            type="date"
          />
          <Select
            label="اسم الموسم"
            value={formData.seasonId}
            onChange={onChange}
            name="seasonId"
          >
            <option value="">اختر</option>
            {seasons.map((season) => (
              <option key={season.seasonId} value={season.seasonId}>
                {season.seasonName} - {season.seasonYear}
              </option>
            ))}
          </Select>

          <Button
            type="submit"
            text="تسجيل"
            isDisabled={
              !(
                (formData.variantId || formData.fabricTransactionId) &&
                formData.quantity &&
                formData.processingDate &&
                formData.variantCode &&
                formData.variantType
              )
            }
          />
        </div>
      </div>
    </form>
  );
};

export default FabricVariantTransactionForm;
